/**
 * Coerce the implied-consent radio value to a boolean.
 *
 * Lives here because both the legacy `privacy` block and the new `consent`
 * block need it: two copies of the same `'false'`-string check had already
 * drifted apart textually, so any future edge case would have had to be fixed
 * in both or they would silently disagree.
 *
 * @param {string|boolean} value - Raw form value
 * @returns {boolean} Whether consent is implied
 */
export default function parseImpliedConsent(value) {
  return value === 'false' ? false : Boolean(value);
}
